import { CONFIG } from '../../core/config';
import { PlannedMaintenanceLibraryItem } from '../planned-maintenance/planned-maintenance-library-item';
import { ViewModel } from '../view-model';
import { EquipmentFailureMode } from './equipment-failure-mode';

export class PlannedMaintenance implements ViewModel {
  friendlyTypeNameSingular: string = 'Planned Maintenance';
  apiRoute: string = CONFIG.apiRoutes.plannedMaintenance;

  selected: boolean;
  id: string;
  failureModes: EquipmentFailureMode[] = [];
  reference: string;
  plannedMaintenanceLibraryItemId: string;
  plannedMaintenanceLibraryItem: PlannedMaintenanceLibraryItem;
  maintenanceStrategyReference: string;
  description: string;
  regulationPerformanceStandardReference: string;
  frequency: number;
  interval: PlannedMaintenanceIntervals = PlannedMaintenanceIntervals.Days;
  equipmentFunctionalFailureId: string;
  activity: PlannedMaintenanceActivity = PlannedMaintenanceActivity.None;
  isSaved: boolean = false;
  selectedInterval: number;

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.id = data.id;

    if (data.failureModes) {
      this.failureModes = data.failureModes.map(
        (details: EquipmentFailureMode) => {
          const newMode = new EquipmentFailureMode();
          newMode.loadFromJson(details);
          return newMode;
        },
      );
    }

    this.reference = data.reference;
    if (data.plannedMaintenanceLibraryItem) {
      this.plannedMaintenanceLibraryItemId =
        data.plannedMaintenanceLibraryItemId;
      this.plannedMaintenanceLibraryItem = new PlannedMaintenanceLibraryItem();
      this.plannedMaintenanceLibraryItem.loadFromJson(
        data.plannedMaintenanceLibraryItem,
      );
    }
    this.maintenanceStrategyReference = data.maintenanceStrategyReference;
    this.description = data.description;
    this.regulationPerformanceStandardReference =
      data.regulationPerformanceStandardReference;
    this.frequency = data.frequency;
    this.interval = data.interval;
    this.activity = data.activity;
    this.equipmentFunctionalFailureId = data.equipmentFunctionalFailureId;
    this.isSaved = data.isSaved;
  }
}

export enum PlannedMaintenanceIntervals {
  Days,
  Weeks,
  Months,
  Years,
  Hours,
}

export enum PlannedMaintenanceActivity {
  None,
  OnCondition,
  ScheduledDiscardOrRestoration,
  FailureFinding,
}
